import infyskillBanner from "../assests/infyskill_banner.png";
import reaidy_banner from "../assests/white logo-reaidy.png";
import reaidy_banner_black from "../assests/logo.png";
import spotmies_banner from "../assests/spotmies_banner.png";
import blank_banner from "../assests/blankLogo.png";
import aarush_banner from "../assests/aarush-reaidy_logo.png";
import workewhere_banner from "../assests/workewhere_banner.png";
import naukritube_banner from "../assests/naukritube_banner5.png";
import reaidy_smallLogo from "../assests/smallLogo.png";
import naukritubeSmallLogo from "../assests/naukritube_banner5.png";
import naukritube_banner_black from "../assests/naukritube_banner5.png";
import vignan_logo from "../assests/vignan_logo.png";
import { isTestServer } from "../api/api_urls";

const productionStorageData = [
  {
    tittle: "Ressume_storage",
    sasToken:
      "sp=racwdl&st=2025-03-21T06:18:01Z&se=2026-03-21T14:18:01Z&sv=2024-11-04&sr=c&sig=jRlYayZymzSKNbPF4772aUNxn6j9qje84D1wmiOWZyE%3D",
    sasUrl:
      "https://reaidystorage.blob.core.windows.net/resumes?sp=racwdl&st=2025-03-21T06:18:01Z&se=2026-03-21T14:18:01Z&sv=2024-11-04&sr=c&sig=jRlYayZymzSKNbPF4772aUNxn6j9qje84D1wmiOWZyE%3D",
    container: "resumes",
    expiryDate: "21-03-2026",
    accountName: "reaidystorage",
    actions: ["interview", "resume"],
  },
  // {
  //   tittle: "ScreenRecord_storage",
  //   sasToken: "sp=racwdli&st=2024-03-20T18:30:00Z&se=2025-01-20T18:29:00Z&sv=2022-11-02&sr=c&sig=zxleJetbHl7Bk0KQRuJITZayiqQCykH8x1oZsUkTI3A%3D",
  //   sasUrl: "https://reaidystorage.blob.core.windows.net/screen-recordings?sp=racwdli&st=2024-03-20T18:30:00Z&se=2025-01-20T18:29:00Z&sv=2022-11-02&sr=c&sig=zxleJetbHl7Bk0KQRuJITZayiqQCykH8x1oZsUkTI3A%3D",
  //   container: "screen-recodings",
  //   expiryDate: "20-03-2025",
  //   accountName: "reaidystorage",
  //   actions: ["recording"]
  // },
  {
    tittle: "Recordings_storage",
    sasToken:
      "sp=racwdl&st=2025-03-21T06:16:23Z&se=2026-03-21T14:16:23Z&sv=2024-11-04&sr=c&sig=v185ciRWT%2FVgzOTqQWXVSoEvFMOQwQVyfMRouOkGzoA%3D",
    sasUrl:
      "https://reaidystorage.blob.core.windows.net/recordings?sp=racwdl&st=2025-03-21T06:16:23Z&se=2026-03-21T14:16:23Z&sv=2024-11-04&sr=c&sig=v185ciRWT%2FVgzOTqQWXVSoEvFMOQwQVyfMRouOkGzoA%3D",
    container: "recordings",
    expiryDate: "21-03-2026",
    accountName: "reaidystorage",
    actions: ["recording"],
  },
  {
    tittle: "User-media_storage",
    sasToken:
      "sp=racwdl&st=2025-03-21T06:20:10Z&se=2026-03-21T14:20:10Z&sv=2024-11-04&sr=c&sig=YlJGLeMxpSURw3zVeNsCfaaP9FGkc8xdMCyiZUsGN9w%3D",
    sasUrl:
      "https://reaidystorage.blob.core.windows.net/user-media?sp=racwdl&st=2025-03-21T06:20:10Z&se=2026-03-21T14:20:10Z&sv=2024-11-04&sr=c&sig=YlJGLeMxpSURw3zVeNsCfaaP9FGkc8xdMCyiZUsGN9w%3D",
    container: "user-media",
    expiryDate: "21-03-2026",
    accountName: "reaidystorage",
    actions: ["profile", "user"],
  },
];

const backupStorageData = [
  {
    tittle: "Ressume_storage",
    sasToken:
      "sp=racwdl&st=2024-12-12T11:38:38Z&se=2025-12-11T19:38:38Z&sv=2022-11-02&sr=c&sig=8ECvIowBKMcAdfsalDsrEMEz7a05N7hQmGF6YGQjcgk%3D",
    sasUrl:
      "https://reaidy.blob.core.windows.net/resumes?sp=racwdl&st=2024-12-12T11:38:38Z&se=2025-12-11T19:38:38Z&sv=2022-11-02&sr=c&sig=8ECvIowBKMcAdfsalDsrEMEz7a05N7hQmGF6YGQjcgk%3D",
    container: "resumes",
    expiryDate: "12-12-2025",
    accountName: "reaidy",
    actions: ["interview", "resume"],
  },
  {
    tittle: "Recordings_storage",
    sasToken:
      "sp=racwdl&st=2024-12-12T11:33:59Z&se=2025-12-11T19:33:59Z&sv=2022-11-02&sr=c&sig=Rk5kthrh4lCktAtYuu%2BEoHQfSjcrhpA8R%2B44pJdyVys%3D",
    sasUrl:
      "https://reaidy.blob.core.windows.net/recordings?sp=racwdl&st=2024-12-12T11:33:59Z&se=2025-12-11T19:33:59Z&sv=2022-11-02&sr=c&sig=Rk5kthrh4lCktAtYuu%2BEoHQfSjcrhpA8R%2B44pJdyVys%3D",
    container: "recordings",
    expiryDate: "12-12-2025",
    accountName: "reaidy",
    actions: ["recording"],
  },
  {
    tittle: "User-media_storage",
    sasToken:
      "sp=racwdl&st=2024-12-12T11:40:04Z&se=2025-12-12T19:40:04Z&sv=2022-11-02&sr=c&sig=MfoATC%2FJmDgBWVt6F4coYPDZ5rvcsKioYzA6p%2F%2B8Fj0%3D",
    sasUrl:
      "https://reaidy.blob.core.windows.net/user-media?sp=racwdl&st=2024-12-12T11:40:04Z&se=2025-12-12T19:40:04Z&sv=2022-11-02&sr=c&sig=MfoATC%2FJmDgBWVt6F4coYPDZ5rvcsKioYzA6p%2F%2B8Fj0%3D",
    container: "user-media",
    expiryDate: "12-12-2025",
    accountName: "reaidy",
    actions: ["profile", "user"],
  },
];

const testStorageData = [
  {
    tittle: "Ressume_storage",
    sasToken:
      "sp=r&st=2025-01-29T15:26:53Z&se=2026-01-29T23:26:53Z&sv=2022-11-02&sr=c&sig=KZswitkx4we%2FLogv4yTaWjw1yiygR21CUgiXcKlHtBM%3D",
    sasUrl:
      "https://testingreaidy.blob.core.windows.net/resumes?sp=r&st=2025-01-29T15:26:53Z&se=2026-01-29T23:26:53Z&sv=2022-11-02&sr=c&sig=KZswitkx4we%2FLogv4yTaWjw1yiygR21CUgiXcKlHtBM%3D",
    container: "resumes",
    expiryDate: "29-01-2026",
    accountName: "testingreaidy",
    actions: ["interview", "resume"],
  },
  {
    tittle: "Recordings_storage",
    sasToken:
      "sp=racwdli&st=2024-12-02T07:19:54Z&se=2025-12-02T15:19:54Z&sv=2022-11-02&sr=c&sig=TIlDkUyHS%2FrZx%2FMjvGNII6VLlwcTrWaFvmZe5DTSskQ%3D",
    sasUrl:
      "https://testingreaidy.blob.core.windows.net/recording?sp=racwdli&st=2024-12-02T07:19:54Z&se=2025-12-02T15:19:54Z&sv=2022-11-02&sr=c&sig=TIlDkUyHS%2FrZx%2FMjvGNII6VLlwcTrWaFvmZe5DTSskQ%3D",
    container: "recordings",
    expiryDate: "29-01-2026",
    accountName: "testingreaidy",
    actions: ["recording"],
  },
  {
    tittle: "User-media_storage",
    sasToken:
      "sp=r&st=2025-01-29T15:27:32Z&se=2026-01-29T23:27:32Z&sv=2022-11-02&sr=c&sig=7oASLBaVP%2BGn48BfPphf%2FvaGgz8nTyMrD3js7pHSOw0%3D",
    sasUrl:
      "https://testingreaidy.blob.core.windows.net/user-media?sp=r&st=2025-01-29T15:27:32Z&se=2026-01-29T23:27:32Z&sv=2022-11-02&sr=c&sig=7oASLBaVP%2BGn48BfPphf%2FvaGgz8nTyMrD3js7pHSOw0%3D",
    container: "user-media",
    expiryDate: "29-01-2026",
    accountName: "testingreaidy",
    actions: ["profile", "user"],
  },
];

const whiteLableList = [
  {
    domain: "infyskill.reaidy.io",
    name: "Infyskill",
    websiteUrl: "WWW.REAIDY.IO",
    cluster: "65eeb0ff14b93e4c5bc91aef",
    smallLogo: reaidy_smallLogo,
    logo: infyskillBanner,
    darkLogo: reaidy_banner_black,
    poweredByLogo: reaidy_banner,
    poweredByURL: "https://www.reaidy.io/",

    entireWhiteLabel: false,
    company: [
      {
        page: "home",
        status: true,
      },
      {
        page: "instant",
        status: true,
      },
      {
        page: "service",
        status: true,
      },
      {
        page: "resume",
        status: true,
      },
      {
        page: "history",
        status: true,
      },
      {
        page: "applicant",
        status: true,
      },
      {
        page: "profile",
        status: true,
      },
    ],
    menu: [
      {
        page: "home",
        status: true,
      },
      {
        page: "learn",
        status: true,
      },
      {
        page: "resume",
        status: true,
      },
      {
        page: "Career",
        status: false,
      },
      {
        page: "profile",
        status: true,
      },
      {
        page: "refer",
        status: true,
      },
      {
        page: "job",
        status: true,
      },
    ],
    storageData: [
      {
        tittle: "Ressume_storage",
        sasToken:
          "sp=racwdl&st=2025-03-21T06:18:01Z&se=2026-03-21T14:18:01Z&sv=2024-11-04&sr=c&sig=jRlYayZymzSKNbPF4772aUNxn6j9qje84D1wmiOWZyE%3D",
        sasUrl:
          "https://reaidystorage.blob.core.windows.net/resumes?sp=racwdl&st=2025-03-21T06:18:01Z&se=2026-03-21T14:18:01Z&sv=2024-11-04&sr=c&sig=jRlYayZymzSKNbPF4772aUNxn6j9qje84D1wmiOWZyE%3D",
        container: "resumes",
        expiryDate: "21-03-2026",
        accountName: "reaidystorage",
        actions: ["interview", "resume"],
      },
      // {
      //   tittle: "ScreenRecord_storage",
      //   sasToken: "sp=racwdli&st=2024-03-20T18:30:00Z&se=2025-01-20T18:29:00Z&sv=2022-11-02&sr=c&sig=zxleJetbHl7Bk0KQRuJITZayiqQCykH8x1oZsUkTI3A%3D",
      //   sasUrl: "https://reaidystorage.blob.core.windows.net/screen-recordings?sp=racwdli&st=2024-03-20T18:30:00Z&se=2025-01-20T18:29:00Z&sv=2022-11-02&sr=c&sig=zxleJetbHl7Bk0KQRuJITZayiqQCykH8x1oZsUkTI3A%3D",
      //   container: "screen-recodings",
      //   expiryDate: "20-03-2025",
      //   accountName: "reaidystorage",
      //   actions: ["recording"]
      // },
      {
        tittle: "Recordings_storage",
        sasToken:
          "sp=racwdl&st=2025-03-21T06:16:23Z&se=2026-03-21T14:16:23Z&sv=2024-11-04&sr=c&sig=v185ciRWT%2FVgzOTqQWXVSoEvFMOQwQVyfMRouOkGzoA%3D",
        sasUrl:
          "https://reaidystorage.blob.core.windows.net/recordings?sp=racwdl&st=2025-03-21T06:16:23Z&se=2026-03-21T14:16:23Z&sv=2024-11-04&sr=c&sig=v185ciRWT%2FVgzOTqQWXVSoEvFMOQwQVyfMRouOkGzoA%3D",
        container: "recordings",
        expiryDate: "21-03-2026",
        accountName: "reaidystorage",
        actions: ["recording"],
      },
      {
        tittle: "User-media_storage",
        sasToken:
          "sp=racwdl&st=2025-03-21T06:20:10Z&se=2026-03-21T14:20:10Z&sv=2024-11-04&sr=c&sig=YlJGLeMxpSURw3zVeNsCfaaP9FGkc8xdMCyiZUsGN9w%3D",
        sasUrl:
          "https://reaidystorage.blob.core.windows.net/user-media?sp=racwdl&st=2025-03-21T06:20:10Z&se=2026-03-21T14:20:10Z&sv=2024-11-04&sr=c&sig=YlJGLeMxpSURw3zVeNsCfaaP9FGkc8xdMCyiZUsGN9w%3D",
        container: "user-media",
        expiryDate: "21-03-2026",
        accountName: "reaidystorage",
        actions: ["profile", "user"],
      },
    ],
  },
  {
    domain: "reaidy.spotmies.com",
    name: "Spotmies",
    websiteUrl: "WWW.REAIDY.IO",
    smallLogo: reaidy_smallLogo,
    logo: reaidy_banner,
    darkLogo: reaidy_banner_black,
    poweredByLogo: spotmies_banner,
    poweredByURL: "https://www.spotmies.com/",
    cluster: "65eeb0ff14b93e4c5bc91aef",
    entireWhiteLabel: true,
    company: [
      {
        page: "home",
        status: true,
      },
      {
        page: "instant",
        status: true,
      },
      {
        page: "service",
        status: true,
      },
      {
        page: "resume",
        status: true,
      },
      {
        page: "history",
        status: true,
      },
      {
        page: "applicant",
        status: true,
      },
      {
        page: "profile",
        status: true,
      },
    ],
    menu: [
      {
        page: "home",
        status: true,
      },
      {
        page: "learn",
        status: true,
      },
      {
        page: "Career",
        status: false,
      },
      {
        page: "resume",
        status: true,
      },
      {
        page: "profile",
        status: true,
      },
      {
        page: "refer",
        status: true,
      },
      {
        page: "job",
        status: true,
      },
    ],
    storageData: [
      {
        tittle: "Ressume_storage",
        sasToken:
          "sp=racwdl&st=2025-03-21T06:18:01Z&se=2026-03-21T14:18:01Z&sv=2024-11-04&sr=c&sig=jRlYayZymzSKNbPF4772aUNxn6j9qje84D1wmiOWZyE%3D",
        sasUrl:
          "https://reaidystorage.blob.core.windows.net/resumes?sp=racwdl&st=2025-03-21T06:18:01Z&se=2026-03-21T14:18:01Z&sv=2024-11-04&sr=c&sig=jRlYayZymzSKNbPF4772aUNxn6j9qje84D1wmiOWZyE%3D",
        container: "resumes",
        expiryDate: "21-03-2026",
        accountName: "reaidystorage",
        actions: ["interview", "resume"],
      },
      // {
      //   tittle: "ScreenRecord_storage",
      //   sasToken: "sp=racwdli&st=2024-03-20T18:30:00Z&se=2025-01-20T18:29:00Z&sv=2022-11-02&sr=c&sig=zxleJetbHl7Bk0KQRuJITZayiqQCykH8x1oZsUkTI3A%3D",
      //   sasUrl: "https://reaidystorage.blob.core.windows.net/screen-recordings?sp=racwdli&st=2024-03-20T18:30:00Z&se=2025-01-20T18:29:00Z&sv=2022-11-02&sr=c&sig=zxleJetbHl7Bk0KQRuJITZayiqQCykH8x1oZsUkTI3A%3D",
      //   container: "screen-recodings",
      //   expiryDate: "20-03-2025",
      //   accountName: "reaidystorage",
      //   actions: ["recording"]
      // },
      {
        tittle: "Recordings_storage",
        sasToken:
          "sp=racwdl&st=2025-03-21T06:16:23Z&se=2026-03-21T14:16:23Z&sv=2024-11-04&sr=c&sig=v185ciRWT%2FVgzOTqQWXVSoEvFMOQwQVyfMRouOkGzoA%3D",
        sasUrl:
          "https://reaidystorage.blob.core.windows.net/recordings?sp=racwdl&st=2025-03-21T06:16:23Z&se=2026-03-21T14:16:23Z&sv=2024-11-04&sr=c&sig=v185ciRWT%2FVgzOTqQWXVSoEvFMOQwQVyfMRouOkGzoA%3D",
        container: "recordings",
        expiryDate: "21-03-2026",
        accountName: "reaidystorage",
        actions: ["recording"],
      },
      {
        tittle: "User-media_storage",
        sasToken:
          "sp=racwdl&st=2025-03-21T06:20:10Z&se=2026-03-21T14:20:10Z&sv=2024-11-04&sr=c&sig=YlJGLeMxpSURw3zVeNsCfaaP9FGkc8xdMCyiZUsGN9w%3D",
        sasUrl:
          "https://reaidystorage.blob.core.windows.net/user-media?sp=racwdl&st=2025-03-21T06:20:10Z&se=2026-03-21T14:20:10Z&sv=2024-11-04&sr=c&sig=YlJGLeMxpSURw3zVeNsCfaaP9FGkc8xdMCyiZUsGN9w%3D",
        container: "user-media",
        expiryDate: "21-03-2026",
        accountName: "reaidystorage",
        actions: ["profile", "user"],
      },
    ],
  },
  {
    domain: "app.reaidy.io",
    name: "Reaidy",
    websiteUrl: "WWW.REAIDY.IO",
    cluster: JSON.parse(localStorage.getItem("user"))?.cluster
      ? JSON.parse(localStorage.getItem("user"))?.cluster
      : "65eeb0ff14b93e4c5bc91aef",
    smallLogo: reaidy_smallLogo,
    logo: reaidy_banner,
    darkLogo: reaidy_banner_black,
    poweredByLogo: spotmies_banner,
    poweredByURL: "https://www.spotmies.com/",
    entireWhiteLabel: true,
    company: [
      {
        page: "home",
        status: true,
      },
      {
        page: "instant",
        status: true,
      },
      {
        page: "service",
        status: true,
      },
      {
        page: "resume",
        status: true,
      },
      {
        page: "history",
        status: true,
      },
      {
        page: "applicant",
        status: true,
      },
      {
        page: "profile",
        status: true,
      },
      {
        page: "labels",
        status: true,
      },
    ],
    menu: [
      {
        page: "home",
        status: true,
      },
      {
        page: "learn",
        status: true,
      },
      {
        page: "resume",
        status: true,
      },
      {
        page: "Career",
        status: true,
      },
      {
        page: "profile",
        status: true,
      },
      {
        page: "refer",
        status: true,
      },
      {
        page: "job",
        status: true,
      },
      {
        page: "labels",
        status: true,
      },
    ],
    storageData: [
      {
        tittle: "Ressume_storage",
        sasToken:
          "sp=racwdl&st=2025-03-21T06:18:01Z&se=2026-03-21T14:18:01Z&sv=2024-11-04&sr=c&sig=jRlYayZymzSKNbPF4772aUNxn6j9qje84D1wmiOWZyE%3D",
        sasUrl:
          "https://reaidystorage.blob.core.windows.net/resumes?sp=racwdl&st=2025-03-21T06:18:01Z&se=2026-03-21T14:18:01Z&sv=2024-11-04&sr=c&sig=jRlYayZymzSKNbPF4772aUNxn6j9qje84D1wmiOWZyE%3D",
        container: "resumes",
        expiryDate: "21-03-2026",
        accountName: "reaidystorage",
        actions: ["interview", "resume"],
      },
      // {
      //   tittle: "ScreenRecord_storage",
      //   sasToken: "sp=racwdli&st=2024-03-20T18:30:00Z&se=2025-01-20T18:29:00Z&sv=2022-11-02&sr=c&sig=zxleJetbHl7Bk0KQRuJITZayiqQCykH8x1oZsUkTI3A%3D",
      //   sasUrl: "https://reaidystorage.blob.core.windows.net/screen-recordings?sp=racwdli&st=2024-03-20T18:30:00Z&se=2025-01-20T18:29:00Z&sv=2022-11-02&sr=c&sig=zxleJetbHl7Bk0KQRuJITZayiqQCykH8x1oZsUkTI3A%3D",
      //   container: "screen-recodings",
      //   expiryDate: "20-03-2025",
      //   accountName: "reaidystorage",
      //   actions: ["recording"]
      // },
      {
        tittle: "Recordings_storage",
        sasToken:
          "sp=racwdl&st=2025-03-21T06:16:23Z&se=2026-03-21T14:16:23Z&sv=2024-11-04&sr=c&sig=v185ciRWT%2FVgzOTqQWXVSoEvFMOQwQVyfMRouOkGzoA%3D",
        sasUrl:
          "https://reaidystorage.blob.core.windows.net/recordings?sp=racwdl&st=2025-03-21T06:16:23Z&se=2026-03-21T14:16:23Z&sv=2024-11-04&sr=c&sig=v185ciRWT%2FVgzOTqQWXVSoEvFMOQwQVyfMRouOkGzoA%3D",
        container: "recordings",
        expiryDate: "21-03-2026",
        accountName: "reaidystorage",
        actions: ["recording"],
      },
      {
        tittle: "User-media_storage",
        sasToken:
          "sp=racwdl&st=2025-03-21T06:20:10Z&se=2026-03-21T14:20:10Z&sv=2024-11-04&sr=c&sig=YlJGLeMxpSURw3zVeNsCfaaP9FGkc8xdMCyiZUsGN9w%3D",
        sasUrl:
          "https://reaidystorage.blob.core.windows.net/user-media?sp=racwdl&st=2025-03-21T06:20:10Z&se=2026-03-21T14:20:10Z&sv=2024-11-04&sr=c&sig=YlJGLeMxpSURw3zVeNsCfaaP9FGkc8xdMCyiZUsGN9w%3D",
        container: "user-media",
        expiryDate: "21-03-2026",
        accountName: "reaidystorage",
        actions: ["profile", "user"],
      },
    ],
  },

  {
    domain: "lucy-pre-prod.vercel.app",
    name: "Reaidy",
    websiteUrl: "WWW.REAIDY.IO",
    cluster: JSON.parse(localStorage.getItem("user"))?.cluster
      ? JSON.parse(localStorage.getItem("user"))?.cluster
      : "65eeb0ff14b93e4c5bc91aef",
    smallLogo: reaidy_smallLogo,
    logo: reaidy_banner,
    darkLogo: reaidy_banner_black,
    poweredByLogo: spotmies_banner,
    poweredByURL: "https://www.spotmies.com/",
    entireWhiteLabel: true,
    company: [
      {
        page: "home",
        status: true,
      },
      {
        page: "instant",
        status: true,
      },
      {
        page: "service",
        status: true,
      },
      {
        page: "resume",
        status: true,
      },
      {
        page: "history",
        status: true,
      },
      {
        page: "applicant",
        status: true,
      },
      {
        page: "profile",
        status: true,
      },
      {
        page: "labels",
        status: true,
      },
    ],
    menu: [
      {
        page: "home",
        status: true,
      },
      {
        page: "learn",
        status: true,
      },
      {
        page: "resume",
        status: true,
      },
      {
        page: "Career",
        status: true,
      },
      {
        page: "profile",
        status: true,
      },
      {
        page: "refer",
        status: true,
      },
      {
        page: "job",
        status: true,
      },
      {
        page: "labels",
        status: true,
      },
    ],
    storageData: [
      {
        tittle: "Ressume_storage",
        sasToken:
          "sp=racwdl&st=2025-03-21T06:18:01Z&se=2026-03-21T14:18:01Z&sv=2024-11-04&sr=c&sig=jRlYayZymzSKNbPF4772aUNxn6j9qje84D1wmiOWZyE%3D",
        sasUrl:
          "https://reaidystorage.blob.core.windows.net/resumes?sp=racwdl&st=2025-03-21T06:18:01Z&se=2026-03-21T14:18:01Z&sv=2024-11-04&sr=c&sig=jRlYayZymzSKNbPF4772aUNxn6j9qje84D1wmiOWZyE%3D",
        container: "resumes",
        expiryDate: "21-03-2026",
        accountName: "reaidystorage",
        actions: ["interview", "resume"],
      },
      // {
      //   tittle: "ScreenRecord_storage",
      //   sasToken: "sp=racwdli&st=2024-03-20T18:30:00Z&se=2025-01-20T18:29:00Z&sv=2022-11-02&sr=c&sig=zxleJetbHl7Bk0KQRuJITZayiqQCykH8x1oZsUkTI3A%3D",
      //   sasUrl: "https://reaidystorage.blob.core.windows.net/screen-recordings?sp=racwdli&st=2024-03-20T18:30:00Z&se=2025-01-20T18:29:00Z&sv=2022-11-02&sr=c&sig=zxleJetbHl7Bk0KQRuJITZayiqQCykH8x1oZsUkTI3A%3D",
      //   container: "screen-recodings",
      //   expiryDate: "20-03-2025",
      //   accountName: "reaidystorage",
      //   actions: ["recording"]
      // },
      {
        tittle: "Recordings_storage",
        sasToken:
          "sp=racwdl&st=2025-03-21T06:16:23Z&se=2026-03-21T14:16:23Z&sv=2024-11-04&sr=c&sig=v185ciRWT%2FVgzOTqQWXVSoEvFMOQwQVyfMRouOkGzoA%3D",
        sasUrl:
          "https://reaidystorage.blob.core.windows.net/recordings?sp=racwdl&st=2025-03-21T06:16:23Z&se=2026-03-21T14:16:23Z&sv=2024-11-04&sr=c&sig=v185ciRWT%2FVgzOTqQWXVSoEvFMOQwQVyfMRouOkGzoA%3D",
        container: "recordings",
        expiryDate: "21-03-2026",
        accountName: "reaidystorage",
        actions: ["recording"],
      },
      {
        tittle: "User-media_storage",
        sasToken:
          "sp=racwdl&st=2025-03-21T06:20:10Z&se=2026-03-21T14:20:10Z&sv=2024-11-04&sr=c&sig=YlJGLeMxpSURw3zVeNsCfaaP9FGkc8xdMCyiZUsGN9w%3D",
        sasUrl:
          "https://reaidystorage.blob.core.windows.net/user-media?sp=racwdl&st=2025-03-21T06:20:10Z&se=2026-03-21T14:20:10Z&sv=2024-11-04&sr=c&sig=YlJGLeMxpSURw3zVeNsCfaaP9FGkc8xdMCyiZUsGN9w%3D",
        container: "user-media",
        expiryDate: "21-03-2026",
        accountName: "reaidystorage",
        actions: ["profile", "user"],
      },
    ],
  },
  {
    domain: "demo.reaidy.io",
    name: "Demo",
    websiteUrl: "WWW.REAIDY.IO",
    cluster: JSON.parse(localStorage.getItem("user"))?.cluster
      ? JSON.parse(localStorage.getItem("user"))?.cluster
      : "65eeb0ff14b93e4c5bc91aef",
    smallLogo: reaidy_smallLogo,
    logo: blank_banner,
    darkLogo: reaidy_banner_black,
    poweredByLogo: blank_banner,
    poweredByURL: "https://www.demo.com/",
    entireWhiteLabel: true,
    company: [
      {
        page: "home",
        status: true,
      },
      {
        page: "instant",
        status: true,
      },
      {
        page: "service",
        status: true,
      },
      {
        page: "resume",
        status: true,
      },
      {
        page: "history",
        status: true,
      },
      {
        page: "applicant",
        status: true,
      },
      {
        page: "profile",
        status: true,
      },
      {
        page: "labels",
        status: true,
      },
    ],
    menu: [
      {
        page: "home",
        status: true,
      },
      {
        page: "learn",
        status: true,
      },
      {
        page: "resume",
        status: true,
      },
      {
        page: "Career",
        status: true,
      },
      {
        page: "profile",
        status: true,
      },
      {
        page: "refer",
        status: true,
      },
      {
        page: "job",
        status: true,
      },
      {
        page: "labels",
        status: true,
      },
    ],
    storageData: [
      {
        tittle: "Ressume_storage",
        sasToken:
          "sp=racwdli&st=2024-11-21T11:24:27Z&se=2025-11-21T19:24:27Z&sv=2022-11-02&sr=c&sig=hxTlBYNA75TXDTnM%2FFBQc5ebvHliBiPJ6lPxAB0gDK0%3D",
        sasUrl:
          "https://reaidyclientbatch1.blob.core.windows.net/recordings?sp=racwdli&st=2024-11-21T11:21:33Z&se=2025-11-21T19:21:33Z&sv=2022-11-02&sr=c&sig=lER9Hc8Wm6XSgnCbrpL%2B2FcQfJL%2F%2B%2FG7TR5I1Iar%2Fnk%3D",
        container: "resumes",
        expiryDate: "11/22/2025",
        accountName: "reaidyclientbatch1",
        actions: ["interview", "resume"],
      },
      {
        tittle: "Recordings_storage",
        sasToken:
          "sp=racwdli&st=2024-11-21T11:21:33Z&se=2025-11-21T19:21:33Z&sv=2022-11-02&sr=c&sig=lER9Hc8Wm6XSgnCbrpL%2B2FcQfJL%2F%2B%2FG7TR5I1Iar%2Fnk%3D",
        sasUrl:
          "https://reaidyclientbatch1.blob.core.windows.net/resumes?sp=racwdli&st=2024-11-21T11:24:27Z&se=2025-11-21T19:24:27Z&sv=2022-11-02&sr=c&sig=hxTlBYNA75TXDTnM%2FFBQc5ebvHliBiPJ6lPxAB0gDK0%3D",
        container: "recordings",
        expiryDate: "11/22/2025",
        accountName: "reaidyclientbatch1",
        actions: ["recording"],
      },
      {
        tittle: "User-media_storage",
        sasToken:
          "sp=racwdli&st=2024-11-21T11:25:59Z&se=2025-11-21T19:25:59Z&sv=2022-11-02&sr=c&sig=KNBnh2iyD9oMJcEMS7zJ1kw5lTP4QG438zAIoy5yXv4%3D",
        sasUrl:
          "https://reaidyclientbatch1.blob.core.windows.net/user-media?sp=racwdli&st=2024-11-21T11:25:59Z&se=2025-11-21T19:25:59Z&sv=2022-11-02&sr=c&sig=KNBnh2iyD9oMJcEMS7zJ1kw5lTP4QG438zAIoy5yXv4%3D",
        container: "user-media",
        expiryDate: "11/22/2025",
        accountName: "reaidyclientbatch1",
        actions: ["profile", "user"],
      },
    ],
  },

  {
    domain: "10.10.6.144",
    name: "Reaidy",
    websiteUrl: "WWW.REAIDY.IO",
    cluster: "65eeb0ff14b93e4c5bc91aef",
    smallLogo: reaidy_smallLogo,
    logo: reaidy_banner,
    darkLogo: reaidy_banner_black,
    poweredByLogo: spotmies_banner,
    poweredByURL: "https://www.spotmies.com/",
    entireWhiteLabel: true,
    menu: [
      {
        page: "home",
        status: true,
      },
      {
        page: "learn",
        status: true,
      },
      {
        page: "resume",
        status: true,
      },
      {
        page: "Career",
        status: true,
      },
      {
        page: "profile",
        status: true,
      },
      {
        page: "refer",
        status: true,
      },
      {
        page: "job",
        status: true,
      },
    ],
    storageData: [
      {
        tittle: "Ressume_storage",
        sasToken:
          "sp=racwdl&st=2025-03-21T06:18:01Z&se=2026-03-21T14:18:01Z&sv=2024-11-04&sr=c&sig=jRlYayZymzSKNbPF4772aUNxn6j9qje84D1wmiOWZyE%3D",
        sasUrl:
          "https://reaidystorage.blob.core.windows.net/resumes?sp=racwdl&st=2025-03-21T06:18:01Z&se=2026-03-21T14:18:01Z&sv=2024-11-04&sr=c&sig=jRlYayZymzSKNbPF4772aUNxn6j9qje84D1wmiOWZyE%3D",
        container: "resumes",
        expiryDate: "21-03-2026",
        accountName: "reaidystorage",
        actions: ["interview", "resume"],
      },
      // {
      //   tittle: "ScreenRecord_storage",
      //   sasToken: "sp=racwdli&st=2024-03-20T18:30:00Z&se=2025-01-20T18:29:00Z&sv=2022-11-02&sr=c&sig=zxleJetbHl7Bk0KQRuJITZayiqQCykH8x1oZsUkTI3A%3D",
      //   sasUrl: "https://reaidystorage.blob.core.windows.net/screen-recordings?sp=racwdli&st=2024-03-20T18:30:00Z&se=2025-01-20T18:29:00Z&sv=2022-11-02&sr=c&sig=zxleJetbHl7Bk0KQRuJITZayiqQCykH8x1oZsUkTI3A%3D",
      //   container: "screen-recodings",
      //   expiryDate: "20-03-2025",
      //   accountName: "reaidystorage",
      //   actions: ["recording"]
      // },
      {
        tittle: "Recordings_storage",
        sasToken:
          "sp=racwdl&st=2025-03-21T06:16:23Z&se=2026-03-21T14:16:23Z&sv=2024-11-04&sr=c&sig=v185ciRWT%2FVgzOTqQWXVSoEvFMOQwQVyfMRouOkGzoA%3D",
        sasUrl:
          "https://reaidystorage.blob.core.windows.net/recordings?sp=racwdl&st=2025-03-21T06:16:23Z&se=2026-03-21T14:16:23Z&sv=2024-11-04&sr=c&sig=v185ciRWT%2FVgzOTqQWXVSoEvFMOQwQVyfMRouOkGzoA%3D",
        container: "recordings",
        expiryDate: "21-03-2026",
        accountName: "reaidystorage",
        actions: ["recording"],
      },
      {
        tittle: "User-media_storage",
        sasToken:
          "sp=racwdl&st=2025-03-21T06:20:10Z&se=2026-03-21T14:20:10Z&sv=2024-11-04&sr=c&sig=YlJGLeMxpSURw3zVeNsCfaaP9FGkc8xdMCyiZUsGN9w%3D",
        sasUrl:
          "https://reaidystorage.blob.core.windows.net/user-media?sp=racwdl&st=2025-03-21T06:20:10Z&se=2026-03-21T14:20:10Z&sv=2024-11-04&sr=c&sig=YlJGLeMxpSURw3zVeNsCfaaP9FGkc8xdMCyiZUsGN9w%3D",
        container: "user-media",
        expiryDate: "21-03-2026",
        accountName: "reaidystorage",
        actions: ["profile", "user"],
      },
    ],
  },
  {
    domain: "10.10.6.144",
    name: "Reaidy",
    websiteUrl: "WWW.REAIDY.IO",
    cluster: "65eeb0ff14b93e4c5bc91aef",
    smallLogo: reaidy_smallLogo,
    logo: reaidy_banner,
    entireWhiteLabel: true,
    menu: [
      {
        page: "home",
        status: true,
      },
      {
        page: "learn",
        status: true,
      },
      {
        page: "resume",
        status: true,
      },
      {
        page: "Career",
        status: true,
      },
      {
        page: "profile",
        status: true,
      },
      {
        page: "refer",
        status: true,
      },
      {
        page: "job",
        status: true,
      },
    ],
    storageData: [
      {
        tittle: "Ressume_storage",
        sasToken:
          "sp=racwdl&st=2025-03-21T06:18:01Z&se=2026-03-21T14:18:01Z&sv=2024-11-04&sr=c&sig=jRlYayZymzSKNbPF4772aUNxn6j9qje84D1wmiOWZyE%3D",
        sasUrl:
          "https://reaidystorage.blob.core.windows.net/resumes?sp=racwdl&st=2025-03-21T06:18:01Z&se=2026-03-21T14:18:01Z&sv=2024-11-04&sr=c&sig=jRlYayZymzSKNbPF4772aUNxn6j9qje84D1wmiOWZyE%3D",
        container: "resumes",
        expiryDate: "21-03-2026",
        accountName: "reaidystorage",
        actions: ["interview", "resume"],
      },
      // {
      //   tittle: "ScreenRecord_storage",
      //   sasToken: "sp=racwdli&st=2024-03-20T18:30:00Z&se=2025-01-20T18:29:00Z&sv=2022-11-02&sr=c&sig=zxleJetbHl7Bk0KQRuJITZayiqQCykH8x1oZsUkTI3A%3D",
      //   sasUrl: "https://reaidystorage.blob.core.windows.net/screen-recordings?sp=racwdli&st=2024-03-20T18:30:00Z&se=2025-01-20T18:29:00Z&sv=2022-11-02&sr=c&sig=zxleJetbHl7Bk0KQRuJITZayiqQCykH8x1oZsUkTI3A%3D",
      //   container: "screen-recodings",
      //   expiryDate: "20-03-2025",
      //   accountName: "reaidystorage",
      //   actions: ["recording"]
      // },
      {
        tittle: "Recordings_storage",
        sasToken:
          "sp=racwdl&st=2025-03-21T06:16:23Z&se=2026-03-21T14:16:23Z&sv=2024-11-04&sr=c&sig=v185ciRWT%2FVgzOTqQWXVSoEvFMOQwQVyfMRouOkGzoA%3D",
        sasUrl:
          "https://reaidystorage.blob.core.windows.net/recordings?sp=racwdl&st=2025-03-21T06:16:23Z&se=2026-03-21T14:16:23Z&sv=2024-11-04&sr=c&sig=v185ciRWT%2FVgzOTqQWXVSoEvFMOQwQVyfMRouOkGzoA%3D",
        container: "recordings",
        expiryDate: "21-03-2026",
        accountName: "reaidystorage",
        actions: ["recording"],
      },
      {
        tittle: "User-media_storage",
        sasToken:
          "sp=racwdl&st=2025-03-21T06:20:10Z&se=2026-03-21T14:20:10Z&sv=2024-11-04&sr=c&sig=YlJGLeMxpSURw3zVeNsCfaaP9FGkc8xdMCyiZUsGN9w%3D",
        sasUrl:
          "https://reaidystorage.blob.core.windows.net/user-media?sp=racwdl&st=2025-03-21T06:20:10Z&se=2026-03-21T14:20:10Z&sv=2024-11-04&sr=c&sig=YlJGLeMxpSURw3zVeNsCfaaP9FGkc8xdMCyiZUsGN9w%3D",
        container: "user-media",
        expiryDate: "21-03-2026",
        accountName: "reaidystorage",
        actions: ["profile", "user"],
      },
    ],
  },
  {
    domain: "app.reaidy.in",
    name: "Reaidy",
    websiteUrl: "WWW.REAIDY.IO",
    cluster: "65eeb0ff14b93e4c5bc91aef",
    smallLogo: reaidy_smallLogo,
    logo: reaidy_banner,
    darkLogo: reaidy_banner_black,
    poweredByLogo: spotmies_banner,
    poweredByURL: "https://www.spotmies.com/",
    entireWhiteLabel: true,
    company: [
      {
        page: "home",
        status: true,
      },
      {
        page: "instant",
        status: true,
      },
      {
        page: "service",
        status: true,
      },
      {
        page: "resume",
        status: true,
      },
      {
        page: "history",
        status: true,
      },
      {
        page: "applicant",
        status: true,
      },
      {
        page: "profile",
        status: true,
      },
    ],
    menu: [
      {
        page: "home",
        status: true,
      },
      {
        page: "learn",
        status: true,
      },
      {
        page: "resume",
        status: true,
      },
      {
        page: "Career",
        status: true,
      },
      {
        page: "profile",
        status: true,
      },
      {
        page: "refer",
        status: true,
      },
      {
        page: "job",
        status: true,
      },
    ],
    storageData: [
      {
        tittle: "Ressume_storage",
        sasToken:
          "sp=racwdl&st=2025-03-21T06:18:01Z&se=2026-03-21T14:18:01Z&sv=2024-11-04&sr=c&sig=jRlYayZymzSKNbPF4772aUNxn6j9qje84D1wmiOWZyE%3D",
        sasUrl:
          "https://reaidystorage.blob.core.windows.net/resumes?sp=racwdl&st=2025-03-21T06:18:01Z&se=2026-03-21T14:18:01Z&sv=2024-11-04&sr=c&sig=jRlYayZymzSKNbPF4772aUNxn6j9qje84D1wmiOWZyE%3D",
        container: "resumes",
        expiryDate: "21-03-2026",
        accountName: "reaidystorage",
        actions: ["interview", "resume"],
      },
      // {
      //   tittle: "ScreenRecord_storage",
      //   sasToken: "sp=racwdli&st=2024-03-20T18:30:00Z&se=2025-01-20T18:29:00Z&sv=2022-11-02&sr=c&sig=zxleJetbHl7Bk0KQRuJITZayiqQCykH8x1oZsUkTI3A%3D",
      //   sasUrl: "https://reaidystorage.blob.core.windows.net/screen-recordings?sp=racwdli&st=2024-03-20T18:30:00Z&se=2025-01-20T18:29:00Z&sv=2022-11-02&sr=c&sig=zxleJetbHl7Bk0KQRuJITZayiqQCykH8x1oZsUkTI3A%3D",
      //   container: "screen-recodings",
      //   expiryDate: "20-03-2025",
      //   accountName: "reaidystorage",
      //   actions: ["recording"]
      // },
      {
        tittle: "Recordings_storage",
        sasToken:
          "sp=racwdl&st=2025-03-21T06:16:23Z&se=2026-03-21T14:16:23Z&sv=2024-11-04&sr=c&sig=v185ciRWT%2FVgzOTqQWXVSoEvFMOQwQVyfMRouOkGzoA%3D",
        sasUrl:
          "https://reaidystorage.blob.core.windows.net/recordings?sp=racwdl&st=2025-03-21T06:16:23Z&se=2026-03-21T14:16:23Z&sv=2024-11-04&sr=c&sig=v185ciRWT%2FVgzOTqQWXVSoEvFMOQwQVyfMRouOkGzoA%3D",
        container: "recordings",
        expiryDate: "21-03-2026",
        accountName: "reaidystorage",
        actions: ["recording"],
      },
      {
        tittle: "User-media_storage",
        sasToken:
          "sp=racwdl&st=2025-03-21T06:20:10Z&se=2026-03-21T14:20:10Z&sv=2024-11-04&sr=c&sig=YlJGLeMxpSURw3zVeNsCfaaP9FGkc8xdMCyiZUsGN9w%3D",
        sasUrl:
          "https://reaidystorage.blob.core.windows.net/user-media?sp=racwdl&st=2025-03-21T06:20:10Z&se=2026-03-21T14:20:10Z&sv=2024-11-04&sr=c&sig=YlJGLeMxpSURw3zVeNsCfaaP9FGkc8xdMCyiZUsGN9w%3D",
        container: "user-media",
        expiryDate: "21-03-2026",
        accountName: "reaidystorage",
        actions: ["profile", "user"],
      },
    ],
  },
  {
    domain: "app.naukritube.in",
    name: "Naukritube",

    websiteUrl: "WWW.NAUKRITUBE.IN",
    cluster: "668d072fb65d4ae6cb2b9101",
    smallLogo: naukritubeSmallLogo,
    logo: naukritube_banner_black,
    darkLogo: naukritube_banner,
    poweredByLogo: naukritube_banner,
    poweredByURL: "https://naukritube.in/",

    entireWhiteLabel: true,
    company: [
      {
        page: "home",
        status: true,
      },
      {
        page: "instant",
        status: true,
      },
      {
        page: "service",
        status: true,
      },
      {
        page: "resume",
        status: true,
      },
      {
        page: "history",
        status: true,
      },
      {
        page: "applicant",
        status: true,
      },
      {
        page: "profile",
        status: true,
      },
    ],
    menu: [
      {
        page: "home",
        status: false,
      },
      {
        page: "learn",
        status: false,
      },
      {
        page: "resume",
        status: true,
      },
      {
        page: "Career",
        status: true,
      },
      {
        page: "profile",
        status: true,
      },
      {
        page: "refer",
        status: true,
      },
      {
        page: "job",
        status: true,
      },
    ],
    storageData: [
      {
        tittle: "Ressume_storage",
        sasToken:
          "sp=racwdli&st=2024-11-21T11:24:27Z&se=2025-11-21T19:24:27Z&sv=2022-11-02&sr=c&sig=hxTlBYNA75TXDTnM%2FFBQc5ebvHliBiPJ6lPxAB0gDK0%3D",
        sasUrl:
          "https://reaidyclientbatch1.blob.core.windows.net/recordings?sp=racwdli&st=2024-11-21T11:21:33Z&se=2025-11-21T19:21:33Z&sv=2022-11-02&sr=c&sig=lER9Hc8Wm6XSgnCbrpL%2B2FcQfJL%2F%2B%2FG7TR5I1Iar%2Fnk%3D",
        container: "resumes",
        expiryDate: "11/22/2025",
        accountName: "reaidyclientbatch1",
        actions: ["interview", "resume"],
      },
      {
        tittle: "Recordings_storage",
        sasToken:
          "sp=racwdli&st=2024-11-21T11:21:33Z&se=2025-11-21T19:21:33Z&sv=2022-11-02&sr=c&sig=lER9Hc8Wm6XSgnCbrpL%2B2FcQfJL%2F%2B%2FG7TR5I1Iar%2Fnk%3D",
        sasUrl:
          "https://reaidyclientbatch1.blob.core.windows.net/resumes?sp=racwdli&st=2024-11-21T11:24:27Z&se=2025-11-21T19:24:27Z&sv=2022-11-02&sr=c&sig=hxTlBYNA75TXDTnM%2FFBQc5ebvHliBiPJ6lPxAB0gDK0%3D",
        container: "recordings",
        expiryDate: "11/22/2025",
        accountName: "reaidyclientbatch1",
        actions: ["recording"],
      },
      {
        tittle: "User-media_storage",
        sasToken:
          "sp=racwdli&st=2024-11-21T11:25:59Z&se=2025-11-21T19:25:59Z&sv=2022-11-02&sr=c&sig=KNBnh2iyD9oMJcEMS7zJ1kw5lTP4QG438zAIoy5yXv4%3D",
        sasUrl:
          "https://reaidyclientbatch1.blob.core.windows.net/user-media?sp=racwdli&st=2024-11-21T11:25:59Z&se=2025-11-21T19:25:59Z&sv=2022-11-02&sr=c&sig=KNBnh2iyD9oMJcEMS7zJ1kw5lTP4QG438zAIoy5yXv4%3D",
        container: "user-media",
        expiryDate: "11/22/2025",
        accountName: "reaidyclientbatch1",
        actions: ["profile", "user"],
      },
    ],
  },

  {
    domain: "naukritube.reaidy.io",
    name: "Naukritube",
    websiteUrl: "WWW.REAIDY.IO",
    cluster: "668d072fb65d4ae6cb2b9101",
    smallLogo: naukritubeSmallLogo,
    logo: naukritube_banner,
    darkLogo: reaidy_banner_black,
    poweredByLogo: naukritube_banner,
    poweredByURL: "https://naukritube.in/",
    entireWhiteLabel: true,
    company: [
      {
        page: "home",
        status: true,
      },
      {
        page: "instant",
        status: true,
      },
      {
        page: "service",
        status: true,
      },
      {
        page: "resume",
        status: true,
      },
      {
        page: "history",
        status: true,
      },
      {
        page: "applicant",
        status: true,
      },
      {
        page: "profile",
        status: true,
      },
    ],
    menu: [
      {
        page: "home",
        status: false,
      },
      {
        page: "learn",
        status: false,
      },
      {
        page: "resume",
        status: true,
      },
      {
        page: "Career",
        status: true,
      },
      {
        page: "profile",
        status: true,
      },
      {
        page: "refer",
        status: true,
      },
      {
        page: "job",
        status: true,
      },
    ],
    storageData: [
      {
        tittle: "Ressume_storage",
        sasToken:
          "sp=racwdli&st=2024-11-21T11:24:27Z&se=2025-11-21T19:24:27Z&sv=2022-11-02&sr=c&sig=hxTlBYNA75TXDTnM%2FFBQc5ebvHliBiPJ6lPxAB0gDK0%3D",
        sasUrl:
          "https://reaidyclientbatch1.blob.core.windows.net/recordings?sp=racwdli&st=2024-11-21T11:21:33Z&se=2025-11-21T19:21:33Z&sv=2022-11-02&sr=c&sig=lER9Hc8Wm6XSgnCbrpL%2B2FcQfJL%2F%2B%2FG7TR5I1Iar%2Fnk%3D",
        container: "resumes",
        expiryDate: "11/22/2025",
        accountName: "reaidyclientbatch1",
        actions: ["interview", "resume"],
      },
      {
        tittle: "Recordings_storage",
        sasToken:
          "sp=racwdli&st=2024-11-21T11:21:33Z&se=2025-11-21T19:21:33Z&sv=2022-11-02&sr=c&sig=lER9Hc8Wm6XSgnCbrpL%2B2FcQfJL%2F%2B%2FG7TR5I1Iar%2Fnk%3D",
        sasUrl:
          "https://reaidyclientbatch1.blob.core.windows.net/resumes?sp=racwdli&st=2024-11-21T11:24:27Z&se=2025-11-21T19:24:27Z&sv=2022-11-02&sr=c&sig=hxTlBYNA75TXDTnM%2FFBQc5ebvHliBiPJ6lPxAB0gDK0%3D",
        container: "recordings",
        expiryDate: "11/22/2025",
        accountName: "reaidyclientbatch1",
        actions: ["recording"],
      },
      {
        tittle: "User-media_storage",
        sasToken:
          "sp=racwdli&st=2024-11-21T11:25:59Z&se=2025-11-21T19:25:59Z&sv=2022-11-02&sr=c&sig=KNBnh2iyD9oMJcEMS7zJ1kw5lTP4QG438zAIoy5yXv4%3D",
        sasUrl:
          "https://reaidyclientbatch1.blob.core.windows.net/user-media?sp=racwdli&st=2024-11-21T11:25:59Z&se=2025-11-21T19:25:59Z&sv=2022-11-02&sr=c&sig=KNBnh2iyD9oMJcEMS7zJ1kw5lTP4QG438zAIoy5yXv4%3D",
        container: "user-media",
        expiryDate: "11/22/2025",
        accountName: "reaidyclientbatch1",
        actions: ["profile", "user"],
      },
    ],
  },
  {
    domain: "qa.reaidy.io",
    name: "Reaidy",
    websiteUrl: "WWW.REAIDY.IO",
    cluster: JSON.parse(localStorage.getItem("user"))?.cluster
      ? JSON.parse(localStorage.getItem("user"))?.cluster
      : "65eeb0ff14b93e4c5bc91aef",
    smallLogo: reaidy_smallLogo,
    logo: reaidy_banner,
    darkLogo: reaidy_banner_black,
    poweredByLogo: spotmies_banner,
    poweredByURL: "https://www.spotmies.com/",
    entireWhiteLabel: true,
    company: [
      {
        page: "home",
        status: true,
      },
      {
        page: "instant",
        status: true,
      },
      {
        page: "service",
        status: true,
      },
      {
        page: "resume",
        status: true,
      },
      {
        page: "history",
        status: true,
      },
      {
        page: "applicant",
        status: true,
      },
      {
        page: "profile",
        status: true,
      },
      {
        page: "labels",
        status: true,
      },
    ],
    menu: [
      {
        page: "home",
        status: true,
      },
      {
        page: "learn",
        status: true,
      },
      {
        page: "resume",
        status: true,
      },
      {
        page: "Career",
        status: true,
      },
      {
        page: "profile",
        status: true,
      },
      {
        page: "refer",
        status: true,
      },
      {
        page: "mock",
        status: true,
      },
      {
        page: "job",
        status: true,
      },
    ],
    storageData: [
      {
        tittle: "Ressume_storage",
        sasToken:
          "sp=racwdl&st=2025-03-21T06:18:01Z&se=2026-03-21T14:18:01Z&sv=2024-11-04&sr=c&sig=jRlYayZymzSKNbPF4772aUNxn6j9qje84D1wmiOWZyE%3D",
        sasUrl:
          "https://reaidystorage.blob.core.windows.net/resumes?sp=racwdl&st=2025-03-21T06:18:01Z&se=2026-03-21T14:18:01Z&sv=2024-11-04&sr=c&sig=jRlYayZymzSKNbPF4772aUNxn6j9qje84D1wmiOWZyE%3D",
        container: "resumes",
        expiryDate: "21-03-2026",
        accountName: "reaidystorage",
        actions: ["interview", "resume"],
      },
      // {
      //   tittle: "ScreenRecord_storage",
      //   sasToken: "sp=racwdli&st=2024-03-20T18:30:00Z&se=2025-01-20T18:29:00Z&sv=2022-11-02&sr=c&sig=zxleJetbHl7Bk0KQRuJITZayiqQCykH8x1oZsUkTI3A%3D",
      //   sasUrl: "https://reaidystorage.blob.core.windows.net/screen-recordings?sp=racwdli&st=2024-03-20T18:30:00Z&se=2025-01-20T18:29:00Z&sv=2022-11-02&sr=c&sig=zxleJetbHl7Bk0KQRuJITZayiqQCykH8x1oZsUkTI3A%3D",
      //   container: "screen-recodings",
      //   expiryDate: "20-03-2025",
      //   accountName: "reaidystorage",
      //   actions: ["recording"]
      // },
      {
        tittle: "Recordings_storage",
        sasToken:
          "sp=racwdl&st=2025-03-21T06:16:23Z&se=2026-03-21T14:16:23Z&sv=2024-11-04&sr=c&sig=v185ciRWT%2FVgzOTqQWXVSoEvFMOQwQVyfMRouOkGzoA%3D",
        sasUrl:
          "https://reaidystorage.blob.core.windows.net/recordings?sp=racwdl&st=2025-03-21T06:16:23Z&se=2026-03-21T14:16:23Z&sv=2024-11-04&sr=c&sig=v185ciRWT%2FVgzOTqQWXVSoEvFMOQwQVyfMRouOkGzoA%3D",
        container: "recordings",
        expiryDate: "21-03-2026",
        accountName: "reaidystorage",
        actions: ["recording"],
      },
      {
        tittle: "User-media_storage",
        sasToken:
          "sp=racwdl&st=2025-03-21T06:20:10Z&se=2026-03-21T14:20:10Z&sv=2024-11-04&sr=c&sig=YlJGLeMxpSURw3zVeNsCfaaP9FGkc8xdMCyiZUsGN9w%3D",
        sasUrl:
          "https://reaidystorage.blob.core.windows.net/user-media?sp=racwdl&st=2025-03-21T06:20:10Z&se=2026-03-21T14:20:10Z&sv=2024-11-04&sr=c&sig=YlJGLeMxpSURw3zVeNsCfaaP9FGkc8xdMCyiZUsGN9w%3D",
        container: "user-media",
        expiryDate: "21-03-2026",
        accountName: "reaidystorage",
        actions: ["profile", "user"],
      },
    ],
  },
  {
    domain: "future.reaidy.io",
    name: "Reaidy",
    websiteUrl: "WWW.REAIDY.IO",
    cluster: JSON.parse(localStorage.getItem("user"))?.cluster
      ? JSON.parse(localStorage.getItem("user"))?.cluster
      : "65eeb0ff14b93e4c5bc91aef",
    smallLogo: reaidy_smallLogo,
    logo: reaidy_banner,
    darkLogo: reaidy_banner_black,
    poweredByLogo: spotmies_banner,
    poweredByURL: "https://www.spotmies.com/",
    entireWhiteLabel: true,
    company: [
      {
        page: "home",
        status: true,
      },
      {
        page: "instant",
        status: true,
      },
      {
        page: "service",
        status: true,
      },
      {
        page: "resume",
        status: true,
      },
      {
        page: "history",
        status: true,
      },
      {
        page: "applicant",
        status: true,
      },
      {
        page: "profile",
        status: true,
      },
      {
        page: "labels",
        status: true,
      },
    ],
    menu: [
      {
        page: "home",
        status: true,
      },
      {
        page: "learn",
        status: true,
      },
      {
        page: "resume",
        status: true,
      },
      {
        page: "Career",
        status: true,
      },
      {
        page: "profile",
        status: true,
      },
      {
        page: "refer",
        status: true,
      },
      {
        page: "mock",
        status: true,
      },
      {
        page: "job",
        status: true,
      },
    ],
    storageData: [
      {
        tittle: "Ressume_storage",
        sasToken:
          "sp=racwdl&st=2025-03-21T06:18:01Z&se=2026-03-21T14:18:01Z&sv=2024-11-04&sr=c&sig=jRlYayZymzSKNbPF4772aUNxn6j9qje84D1wmiOWZyE%3D",
        sasUrl:
          "https://reaidystorage.blob.core.windows.net/resumes?sp=racwdl&st=2025-03-21T06:18:01Z&se=2026-03-21T14:18:01Z&sv=2024-11-04&sr=c&sig=jRlYayZymzSKNbPF4772aUNxn6j9qje84D1wmiOWZyE%3D",
        container: "resumes",
        expiryDate: "21-03-2026",
        accountName: "reaidystorage",
        actions: ["interview", "resume"],
      },
      // {
      //   tittle: "ScreenRecord_storage",
      //   sasToken: "sp=racwdli&st=2024-03-20T18:30:00Z&se=2025-01-20T18:29:00Z&sv=2022-11-02&sr=c&sig=zxleJetbHl7Bk0KQRuJITZayiqQCykH8x1oZsUkTI3A%3D",
      //   sasUrl: "https://reaidystorage.blob.core.windows.net/screen-recordings?sp=racwdli&st=2024-03-20T18:30:00Z&se=2025-01-20T18:29:00Z&sv=2022-11-02&sr=c&sig=zxleJetbHl7Bk0KQRuJITZayiqQCykH8x1oZsUkTI3A%3D",
      //   container: "screen-recodings",
      //   expiryDate: "20-03-2025",
      //   accountName: "reaidystorage",
      //   actions: ["recording"]
      // },
      {
        tittle: "Recordings_storage",
        sasToken:
          "sp=racwdl&st=2025-03-21T06:16:23Z&se=2026-03-21T14:16:23Z&sv=2024-11-04&sr=c&sig=v185ciRWT%2FVgzOTqQWXVSoEvFMOQwQVyfMRouOkGzoA%3D",
        sasUrl:
          "https://reaidystorage.blob.core.windows.net/recordings?sp=racwdl&st=2025-03-21T06:16:23Z&se=2026-03-21T14:16:23Z&sv=2024-11-04&sr=c&sig=v185ciRWT%2FVgzOTqQWXVSoEvFMOQwQVyfMRouOkGzoA%3D",
        container: "recordings",
        expiryDate: "21-03-2026",
        accountName: "reaidystorage",
        actions: ["recording"],
      },
      {
        tittle: "User-media_storage",
        sasToken:
          "sp=racwdl&st=2025-03-21T06:20:10Z&se=2026-03-21T14:20:10Z&sv=2024-11-04&sr=c&sig=YlJGLeMxpSURw3zVeNsCfaaP9FGkc8xdMCyiZUsGN9w%3D",
        sasUrl:
          "https://reaidystorage.blob.core.windows.net/user-media?sp=racwdl&st=2025-03-21T06:20:10Z&se=2026-03-21T14:20:10Z&sv=2024-11-04&sr=c&sig=YlJGLeMxpSURw3zVeNsCfaaP9FGkc8xdMCyiZUsGN9w%3D",
        container: "user-media",
        expiryDate: "21-03-2026",
        accountName: "reaidystorage",
        actions: ["profile", "user"],
      },
    ],
  },
  {
    domain: "10.10.6.24",
    name: "Reaidy",
    websiteUrl: "WWW.REAIDY.IO",
    cluster: JSON.parse(localStorage.getItem("user"))?.cluster
      ? JSON.parse(localStorage.getItem("user"))?.cluster
      : "65eeb0ff14b93e4c5bc91aef",
    smallLogo: reaidy_smallLogo,
    logo: reaidy_banner,
    logo2: reaidy_banner_black,
    darkLogo: reaidy_banner_black,
    poweredByLogo: spotmies_banner,
    poweredByURL: "https://www.spotmies.com/",
    entireWhiteLabel: true,
    company: [
      {
        page: "home",
        status: true,
      },
      {
        page: "instant",
        status: true,
      },
      {
        page: "service",
        status: true,
      },
      {
        page: "resume",
        status: true,
      },
      {
        page: "history",
        status: true,
      },
      {
        page: "applicant",
        status: true,
      },
      {
        page: "profile",
        status: true,
      },
    ],
    menu: [
      {
        page: "home",
        status: true,
      },
      {
        page: "learn",
        status: true,
      },
      {
        page: "resume",
        status: true,
      },
      {
        page: "Career",
        status: true,
      },
      {
        page: "profile",
        status: true,
      },
      {
        page: "refer",
        status: true,
      },
      {
        page: "mock",
        status: true,
      },
      {
        page: "job",
        status: true,
      },
    ],
    storageData: [
      {
        tittle: "Ressume_storage",
        sasToken:
          "sp=racwdl&st=2025-03-21T06:18:01Z&se=2026-03-21T14:18:01Z&sv=2024-11-04&sr=c&sig=jRlYayZymzSKNbPF4772aUNxn6j9qje84D1wmiOWZyE%3D",
        sasUrl:
          "https://reaidystorage.blob.core.windows.net/resumes?sp=racwdl&st=2025-03-21T06:18:01Z&se=2026-03-21T14:18:01Z&sv=2024-11-04&sr=c&sig=jRlYayZymzSKNbPF4772aUNxn6j9qje84D1wmiOWZyE%3D",
        container: "resumes",
        expiryDate: "21-03-2026",
        accountName: "reaidystorage",
        actions: ["interview", "resume"],
      },
      // {
      //   tittle: "ScreenRecord_storage",
      //   sasToken: "sp=racwdli&st=2024-03-20T18:30:00Z&se=2025-01-20T18:29:00Z&sv=2022-11-02&sr=c&sig=zxleJetbHl7Bk0KQRuJITZayiqQCykH8x1oZsUkTI3A%3D",
      //   sasUrl: "https://reaidystorage.blob.core.windows.net/screen-recordings?sp=racwdli&st=2024-03-20T18:30:00Z&se=2025-01-20T18:29:00Z&sv=2022-11-02&sr=c&sig=zxleJetbHl7Bk0KQRuJITZayiqQCykH8x1oZsUkTI3A%3D",
      //   container: "screen-recodings",
      //   expiryDate: "20-03-2025",
      //   accountName: "reaidystorage",
      //   actions: ["recording"]
      // },
      {
        tittle: "Recordings_storage",
        sasToken:
          "sp=racwdl&st=2025-03-21T06:16:23Z&se=2026-03-21T14:16:23Z&sv=2024-11-04&sr=c&sig=v185ciRWT%2FVgzOTqQWXVSoEvFMOQwQVyfMRouOkGzoA%3D",
        sasUrl:
          "https://reaidystorage.blob.core.windows.net/recordings?sp=racwdl&st=2025-03-21T06:16:23Z&se=2026-03-21T14:16:23Z&sv=2024-11-04&sr=c&sig=v185ciRWT%2FVgzOTqQWXVSoEvFMOQwQVyfMRouOkGzoA%3D",
        container: "recordings",
        expiryDate: "21-03-2026",
        accountName: "reaidystorage",
        actions: ["recording"],
      },
      {
        tittle: "User-media_storage",
        sasToken:
          "sp=racwdl&st=2025-03-21T06:20:10Z&se=2026-03-21T14:20:10Z&sv=2024-11-04&sr=c&sig=YlJGLeMxpSURw3zVeNsCfaaP9FGkc8xdMCyiZUsGN9w%3D",
        sasUrl:
          "https://reaidystorage.blob.core.windows.net/user-media?sp=racwdl&st=2025-03-21T06:20:10Z&se=2026-03-21T14:20:10Z&sv=2024-11-04&sr=c&sig=YlJGLeMxpSURw3zVeNsCfaaP9FGkc8xdMCyiZUsGN9w%3D",
        container: "user-media",
        expiryDate: "21-03-2026",
        accountName: "reaidystorage",
        actions: ["profile", "user"],
      },
    ],
  },
  {
    domain: "localhost",
    name: "localhost",
    websiteUrl: "WWW.REAIDY.IO",
    cluster: JSON.parse(localStorage.getItem("user"))?.cluster
      ? JSON.parse(localStorage.getItem("user"))?.cluster
      : "65eeb0ff14b93e4c5bc91aef",
    smallLogo: reaidy_smallLogo,
    logo: reaidy_banner,
    darkLogo: reaidy_banner_black,
    poweredByLogo: spotmies_banner,
    poweredByURL: "https://www.spotmies.com/",
    entireWhiteLabel: true,
    company: [
      {
        page: "home",
        status: true,
      },
      {
        page: "instant",
        status: true,
      },
      {
        page: "service",
        status: true,
      },
      {
        page: "resume",
        status: true,
      },
      {
        page: "history",
        status: true,
      },
      {
        page: "applicant",
        status: true,
      },
      {
        page: "profile",
        status: true,
      },
      {
        page: "labels",
        status: true,
      },
    ],
    menu: [
      {
        page: "home",
        status: true,
      },
      {
        page: "learn",
        status: true,
      },
      {
        page: "resume",
        status: true,
      },
      {
        page: "Career",
        status: true,
      },
      {
        page: "profile",
        status: true,
      },
      {
        page: "refer",
        status: true,
      },
      {
        page: "mock",
        status: true,
      },
      {
        page: "job",
        status: true,
      },
    ],

    storageData: [
      {
        tittle: "Ressume_test_storage",
        sasToken:
          "sp=racwdli&st=2025-09-24T06:27:25Z&se=2026-09-11T14:42:25Z&sv=2024-11-04&sr=c&sig=c3GMcsLsJGkAMHb5VS0VPktrLJcRMLdIdafWRnbEV1g%3D",
        sasUrl:
          "https://reaidytesting.blob.core.windows.net/resumes?sp=racwdli&st=2025-09-24T06:27:25Z&se=2026-09-11T14:42:25Z&sv=2024-11-04&sr=c&sig=c3GMcsLsJGkAMHb5VS0VPktrLJcRMLdIdafWRnbEV1g%3D",
        container: "resumes",
        expiryDate: "09/11/2026",
        accountName: "reaidytesting",
        actions: ["interview", "resume"],
      },
      {
        tittle: "Recordings_test_storage",
        sasToken:
          "sp=racwdli&st=2025-09-11T10:03:51Z&se=2026-09-11T18:18:51Z&sv=2024-11-04&sr=c&sig=KwueCb%2F%2B86widvqn2UoFGmvY%2BP7lBgYQZ6n8DBCJpaY%3D",
        sasUrl:
          "https://reaidytesting.blob.core.windows.net/recordings?sp=racwdli&st=2025-09-11T10:03:51Z&se=2026-09-11T18:18:51Z&sv=2024-11-04&sr=c&sig=KwueCb%2F%2B86widvqn2UoFGmvY%2BP7lBgYQZ6n8DBCJpaY%3D",
        container: "recordings",
        expiryDate: "09/11/2026",
        accountName: "reaidytesting",
        actions: ["recording"],
      },
      {
        tittle: "User-media_test_storage",
        sasToken:
          "sp=racwdli&st=2025-09-11T10:04:58Z&se=2026-09-11T18:19:58Z&sv=2024-11-04&sr=c&sig=xSLjLjWJhATY%2FmQnNoZwomHfZsns7Z3%2BwZvoK0sjc3o%3D",
        sasUrl:
          "https://reaidytesting.blob.core.windows.net/user-media?sp=racwdli&st=2025-09-11T10:04:58Z&se=2026-09-11T18:19:58Z&sv=2024-11-04&sr=c&sig=xSLjLjWJhATY%2FmQnNoZwomHfZsns7Z3%2BwZvoK0sjc3o%3D",
        container: "user-media",
        expiryDate: "09/11/2026",
        accountName: "reaidytesting",
        actions: ["profile", "user"],
      },
    ],
    // storageData: [
    //   {
    //     tittle: "Ressume_storage",
    //     sasToken:
    //       "sp=racwdl&st=2025-03-21T06:18:01Z&se=2026-03-21T14:18:01Z&sv=2024-11-04&sr=c&sig=jRlYayZymzSKNbPF4772aUNxn6j9qje84D1wmiOWZyE%3D",
    //     sasUrl:
    //       "https://reaidystorage.blob.core.windows.net/resumes?sp=racwdl&st=2025-03-21T06:18:01Z&se=2026-03-21T14:18:01Z&sv=2024-11-04&sr=c&sig=jRlYayZymzSKNbPF4772aUNxn6j9qje84D1wmiOWZyE%3D",
    //     container: "resumes",
    //     expiryDate: "21-03-2026",
    //     accountName: "reaidystorage",
    //     actions: ["interview", "resume"],
    //   },
    //   // {
    //   //   tittle: "ScreenRecord_storage",
    //   //   sasToken: "sp=racwdli&st=2024-03-20T18:30:00Z&se=2025-01-20T18:29:00Z&sv=2022-11-02&sr=c&sig=zxleJetbHl7Bk0KQRuJITZayiqQCykH8x1oZsUkTI3A%3D",
    //   //   sasUrl: "https://reaidystorage.blob.core.windows.net/screen-recordings?sp=racwdli&st=2024-03-20T18:30:00Z&se=2025-01-20T18:29:00Z&sv=2022-11-02&sr=c&sig=zxleJetbHl7Bk0KQRuJITZayiqQCykH8x1oZsUkTI3A%3D",
    //   //   container: "screen-recodings",
    //   //   expiryDate: "20-03-2025",
    //   //   accountName: "reaidystorage",
    //   //   actions: ["recording"]
    //   // },
    //   {
    //     tittle: "Recordings_storage",
    //     sasToken:
    //       "sp=racwdl&st=2025-03-21T06:16:23Z&se=2026-03-21T14:16:23Z&sv=2024-11-04&sr=c&sig=v185ciRWT%2FVgzOTqQWXVSoEvFMOQwQVyfMRouOkGzoA%3D",
    //     sasUrl:
    //       "https://reaidystorage.blob.core.windows.net/recordings?sp=racwdl&st=2025-03-21T06:16:23Z&se=2026-03-21T14:16:23Z&sv=2024-11-04&sr=c&sig=v185ciRWT%2FVgzOTqQWXVSoEvFMOQwQVyfMRouOkGzoA%3D",
    //     container: "recordings",
    //     expiryDate: "21-03-2026",
    //     accountName: "reaidystorage",
    //     actions: ["recording"],
    //   },
    //   {
    //     tittle: "User-media_storage",
    //     sasToken:
    //       "sp=racwdl&st=2025-03-21T06:20:10Z&se=2026-03-21T14:20:10Z&sv=2024-11-04&sr=c&sig=YlJGLeMxpSURw3zVeNsCfaaP9FGkc8xdMCyiZUsGN9w%3D",
    //     sasUrl:
    //       "https://reaidystorage.blob.core.windows.net/user-media?sp=racwdl&st=2025-03-21T06:20:10Z&se=2026-03-21T14:20:10Z&sv=2024-11-04&sr=c&sig=YlJGLeMxpSURw3zVeNsCfaaP9FGkc8xdMCyiZUsGN9w%3D",
    //     container: "user-media",
    //     expiryDate: "21-03-2026",
    //     accountName: "reaidystorage",
    //     actions: ["profile", "user"],
    //   },
    // ],
  },
  {
    domain: "10.10.0.236",
    name: "Reaidy",
    websiteUrl: "WWW.REAIDY.IO",
    cluster: JSON.parse(localStorage.getItem("user"))?.cluster
      ? JSON.parse(localStorage.getItem("user"))?.cluster
      : "65eeb0ff14b93e4c5bc91aef",
    smallLogo: reaidy_smallLogo,
    logo: reaidy_banner,
    darkLogo: reaidy_banner_black,
    poweredByLogo: spotmies_banner,
    poweredByURL: "https://www.spotmies.com/",
    entireWhiteLabel: true,
    company: [
      {
        page: "home",
        status: true,
      },
      {
        page: "instant",
        status: true,
      },
      {
        page: "service",
        status: true,
      },
      {
        page: "resume",
        status: true,
      },
      {
        page: "history",
        status: true,
      },
      {
        page: "applicant",
        status: true,
      },
      {
        page: "profile",
        status: true,
      },
      {
        page: "labels",
        status: true,
      },
    ],
    menu: [
      {
        page: "home",
        status: true,
      },
      {
        page: "learn",
        status: true,
      },
      {
        page: "resume",
        status: true,
      },
      {
        page: "Career",
        status: true,
      },
      {
        page: "profile",
        status: true,
      },
      {
        page: "refer",
        status: true,
      },
      {
        page: "mock",
        status: true,
      },
      {
        page: "job",
        status: true,
      },
    ],
    storageData: [
      {
        tittle: "Ressume_storage",
        sasToken:
          "sp=racwdl&st=2025-03-21T06:18:01Z&se=2026-03-21T14:18:01Z&sv=2024-11-04&sr=c&sig=jRlYayZymzSKNbPF4772aUNxn6j9qje84D1wmiOWZyE%3D",
        sasUrl:
          "https://reaidystorage.blob.core.windows.net/resumes?sp=racwdl&st=2025-03-21T06:18:01Z&se=2026-03-21T14:18:01Z&sv=2024-11-04&sr=c&sig=jRlYayZymzSKNbPF4772aUNxn6j9qje84D1wmiOWZyE%3D",
        container: "resumes",
        expiryDate: "21-03-2026",
        accountName: "reaidystorage",
        actions: ["interview", "resume"],
      },
      // {
      //   tittle: "ScreenRecord_storage",
      //   sasToken: "sp=racwdli&st=2024-03-20T18:30:00Z&se=2025-01-20T18:29:00Z&sv=2022-11-02&sr=c&sig=zxleJetbHl7Bk0KQRuJITZayiqQCykH8x1oZsUkTI3A%3D",
      //   sasUrl: "https://reaidystorage.blob.core.windows.net/screen-recordings?sp=racwdli&st=2024-03-20T18:30:00Z&se=2025-01-20T18:29:00Z&sv=2022-11-02&sr=c&sig=zxleJetbHl7Bk0KQRuJITZayiqQCykH8x1oZsUkTI3A%3D",
      //   container: "screen-recodings",
      //   expiryDate: "20-03-2025",
      //   accountName: "reaidystorage",
      //   actions: ["recording"]
      // },
      {
        tittle: "Recordings_storage",
        sasToken:
          "sp=racwdl&st=2025-03-21T06:16:23Z&se=2026-03-21T14:16:23Z&sv=2024-11-04&sr=c&sig=v185ciRWT%2FVgzOTqQWXVSoEvFMOQwQVyfMRouOkGzoA%3D",
        sasUrl:
          "https://reaidystorage.blob.core.windows.net/recordings?sp=racwdl&st=2025-03-21T06:16:23Z&se=2026-03-21T14:16:23Z&sv=2024-11-04&sr=c&sig=v185ciRWT%2FVgzOTqQWXVSoEvFMOQwQVyfMRouOkGzoA%3D",
        container: "recordings",
        expiryDate: "21-03-2026",
        accountName: "reaidystorage",
        actions: ["recording"],
      },
      {
        tittle: "User-media_storage",
        sasToken:
          "sp=racwdl&st=2025-03-21T06:20:10Z&se=2026-03-21T14:20:10Z&sv=2024-11-04&sr=c&sig=YlJGLeMxpSURw3zVeNsCfaaP9FGkc8xdMCyiZUsGN9w%3D",
        sasUrl:
          "https://reaidystorage.blob.core.windows.net/user-media?sp=racwdl&st=2025-03-21T06:20:10Z&se=2026-03-21T14:20:10Z&sv=2024-11-04&sr=c&sig=YlJGLeMxpSURw3zVeNsCfaaP9FGkc8xdMCyiZUsGN9w%3D",
        container: "user-media",
        expiryDate: "21-03-2026",
        accountName: "reaidystorage",
        actions: ["profile", "user"],
      },
    ],
  },
  {
    domain: "aarushsoft.reaidy.io",
    name: "aarushsoft",
    cluster: "65fac28ceff68ae1bdade510",
    smallLogo: reaidy_smallLogo,
    logo: aarush_banner,
    darkLogo: reaidy_banner_black,
    poweredByLogo: reaidy_banner,
    poweredByURL: "https://www.reaidy.io/",
    entireWhiteLabel: true,
    company: [
      {
        page: "home",
        status: true,
      },
      {
        page: "instant",
        status: true,
      },
      {
        page: "service",
        status: true,
      },
      {
        page: "resume",
        status: true,
      },
      {
        page: "history",
        status: true,
      },
      {
        page: "applicant",
        status: true,
      },
      {
        page: "profile",
        status: true,
      },
    ],
    menu: [
      {
        page: "home",
        status: true,
      },
      {
        page: "learn",
        status: false,
      },
      {
        page: "resume",
        status: true,
      },
      {
        page: "Career",
        status: false,
      },
      {
        page: "profile",
        status: true,
      },
      {
        page: "refer",
        status: true,
      },
      {
        page: "job",
        status: true,
      },
    ],
    storageData: [
      {
        tittle: "Ressume_storage",
        sasToken:
          "sp=racwdl&st=2025-03-21T06:18:01Z&se=2026-03-21T14:18:01Z&sv=2024-11-04&sr=c&sig=jRlYayZymzSKNbPF4772aUNxn6j9qje84D1wmiOWZyE%3D",
        sasUrl:
          "https://reaidystorage.blob.core.windows.net/resumes?sp=racwdl&st=2025-03-21T06:18:01Z&se=2026-03-21T14:18:01Z&sv=2024-11-04&sr=c&sig=jRlYayZymzSKNbPF4772aUNxn6j9qje84D1wmiOWZyE%3D",
        container: "resumes",
        expiryDate: "21-03-2026",
        accountName: "reaidystorage",
        actions: ["interview", "resume"],
      },
      // {
      //   tittle: "ScreenRecord_storage",
      //   sasToken: "sp=racwdli&st=2024-03-20T18:30:00Z&se=2025-01-20T18:29:00Z&sv=2022-11-02&sr=c&sig=zxleJetbHl7Bk0KQRuJITZayiqQCykH8x1oZsUkTI3A%3D",
      //   sasUrl: "https://reaidystorage.blob.core.windows.net/screen-recordings?sp=racwdli&st=2024-03-20T18:30:00Z&se=2025-01-20T18:29:00Z&sv=2022-11-02&sr=c&sig=zxleJetbHl7Bk0KQRuJITZayiqQCykH8x1oZsUkTI3A%3D",
      //   container: "screen-recodings",
      //   expiryDate: "20-03-2025",
      //   accountName: "reaidystorage",
      //   actions: ["recording"]
      // },
      {
        tittle: "Recordings_storage",
        sasToken:
          "sp=racwdl&st=2025-03-21T06:16:23Z&se=2026-03-21T14:16:23Z&sv=2024-11-04&sr=c&sig=v185ciRWT%2FVgzOTqQWXVSoEvFMOQwQVyfMRouOkGzoA%3D",
        sasUrl:
          "https://reaidystorage.blob.core.windows.net/recordings?sp=racwdl&st=2025-03-21T06:16:23Z&se=2026-03-21T14:16:23Z&sv=2024-11-04&sr=c&sig=v185ciRWT%2FVgzOTqQWXVSoEvFMOQwQVyfMRouOkGzoA%3D",
        container: "recordings",
        expiryDate: "21-03-2026",
        accountName: "reaidystorage",
        actions: ["recording"],
      },
      {
        tittle: "User-media_storage",
        sasToken:
          "sp=racwdl&st=2025-03-21T06:20:10Z&se=2026-03-21T14:20:10Z&sv=2024-11-04&sr=c&sig=YlJGLeMxpSURw3zVeNsCfaaP9FGkc8xdMCyiZUsGN9w%3D",
        sasUrl:
          "https://reaidystorage.blob.core.windows.net/user-media?sp=racwdl&st=2025-03-21T06:20:10Z&se=2026-03-21T14:20:10Z&sv=2024-11-04&sr=c&sig=YlJGLeMxpSURw3zVeNsCfaaP9FGkc8xdMCyiZUsGN9w%3D",
        container: "user-media",
        expiryDate: "21-03-2026",
        accountName: "reaidystorage",
        actions: ["profile", "user"],
      },
    ],
  },
  {
    domain: "interview.workewhere.nl",
    name: "Workewhere",
    websiteUrl: "WWW.REAIDY.IO",
    cluster: "6620f5c13308ab30b54374a3",
    smallLogo: reaidy_smallLogo,
    logo: workewhere_banner,
    darkLogo: reaidy_banner_black,
    poweredByLogo: reaidy_banner,
    poweredByURL: "https://www.reaidy.io/",
    entireWhiteLabel: true,
    company: [
      {
        page: "home",
        status: true,
      },
      {
        page: "instant",
        status: true,
      },
      {
        page: "service",
        status: true,
      },
      {
        page: "resume",
        status: true,
      },
      {
        page: "history",
        status: true,
      },
      {
        page: "applicant",
        status: true,
      },
      {
        page: "profile",
        status: true,
      },
    ],
    menu: [
      {
        page: "home",
        status: true,
      },
      {
        page: "learn",
        status: true,
      },
      {
        page: "resume",
        status: true,
      },
      {
        page: "Career",
        status: true,
      },
      {
        page: "profile",
        status: true,
      },
      {
        page: "refer",
        status: true,
      },
      {
        page: "job",
        status: true,
      },
    ],
    storageData: [
      {
        tittle: "Ressume_storage",
        sasToken:
          "sp=racwdl&st=2025-03-21T06:18:01Z&se=2026-03-21T14:18:01Z&sv=2024-11-04&sr=c&sig=jRlYayZymzSKNbPF4772aUNxn6j9qje84D1wmiOWZyE%3D",
        sasUrl:
          "https://reaidystorage.blob.core.windows.net/resumes?sp=racwdl&st=2025-03-21T06:18:01Z&se=2026-03-21T14:18:01Z&sv=2024-11-04&sr=c&sig=jRlYayZymzSKNbPF4772aUNxn6j9qje84D1wmiOWZyE%3D",
        container: "resumes",
        expiryDate: "21-03-2026",
        accountName: "reaidystorage",
        actions: ["interview", "resume"],
      },
      // {
      //   tittle: "ScreenRecord_storage",
      //   sasToken: "sp=racwdli&st=2024-03-20T18:30:00Z&se=2025-01-20T18:29:00Z&sv=2022-11-02&sr=c&sig=zxleJetbHl7Bk0KQRuJITZayiqQCykH8x1oZsUkTI3A%3D",
      //   sasUrl: "https://reaidystorage.blob.core.windows.net/screen-recordings?sp=racwdli&st=2024-03-20T18:30:00Z&se=2025-01-20T18:29:00Z&sv=2022-11-02&sr=c&sig=zxleJetbHl7Bk0KQRuJITZayiqQCykH8x1oZsUkTI3A%3D",
      //   container: "screen-recodings",
      //   expiryDate: "20-03-2025",
      //   accountName: "reaidystorage",
      //   actions: ["recording"]
      // },
      {
        tittle: "Recordings_storage",
        sasToken:
          "sp=racwdl&st=2025-03-21T06:16:23Z&se=2026-03-21T14:16:23Z&sv=2024-11-04&sr=c&sig=v185ciRWT%2FVgzOTqQWXVSoEvFMOQwQVyfMRouOkGzoA%3D",
        sasUrl:
          "https://reaidystorage.blob.core.windows.net/recordings?sp=racwdl&st=2025-03-21T06:16:23Z&se=2026-03-21T14:16:23Z&sv=2024-11-04&sr=c&sig=v185ciRWT%2FVgzOTqQWXVSoEvFMOQwQVyfMRouOkGzoA%3D",
        container: "recordings",
        expiryDate: "21-03-2026",
        accountName: "reaidystorage",
        actions: ["recording"],
      },
      {
        tittle: "User-media_storage",
        sasToken:
          "sp=racwdl&st=2025-03-21T06:20:10Z&se=2026-03-21T14:20:10Z&sv=2024-11-04&sr=c&sig=YlJGLeMxpSURw3zVeNsCfaaP9FGkc8xdMCyiZUsGN9w%3D",
        sasUrl:
          "https://reaidystorage.blob.core.windows.net/user-media?sp=racwdl&st=2025-03-21T06:20:10Z&se=2026-03-21T14:20:10Z&sv=2024-11-04&sr=c&sig=YlJGLeMxpSURw3zVeNsCfaaP9FGkc8xdMCyiZUsGN9w%3D",
        container: "user-media",
        expiryDate: "21-03-2026",
        accountName: "reaidystorage",
        actions: ["profile", "user"],
      },
    ],
  },
  {
    domain: "view.reaidy.io",
    name: "view",
    websiteUrl: "WWW.REAIDY.IO",
    cluster: "66054549edc5aef72fa726b4",
    smallLogo: reaidy_smallLogo,
    logo: vignan_logo,
    darkLogo: reaidy_banner_black,
    poweredByLogo: reaidy_banner,
    poweredByURL: "https://www.reaidy.io/",
    // smallLogo: reaidy_smallLogo,
    logo: workewhere_banner,
    entireWhiteLabel: true,
    company: [
      {
        page: "home",
        status: true,
      },
      {
        page: "instant",
        status: true,
      },
      {
        page: "service",
        status: true,
      },
      {
        page: "resume",
        status: false,
      },
      {
        page: "history",
        status: true,
      },
      {
        page: "applicant",
        status: true,
      },
      {
        page: "profile",
        status: true,
      },
    ],
    menu: [
      {
        page: "home",
        status: true,
      },
      {
        page: "learn",
        status: true,
      },
      {
        page: "Career",
        status: false,
      },
      {
        page: "resume",
        status: true,
      },
      {
        page: "profile",
        status: true,
      },
      {
        page: "refer",
        status: true,
      },
      {
        page: "job",
        status: true,
      },
    ],
    storageData: [
      {
        tittle: "Ressume_storage",
        sasToken:
          "sp=racwdl&st=2025-03-21T06:18:01Z&se=2026-03-21T14:18:01Z&sv=2024-11-04&sr=c&sig=jRlYayZymzSKNbPF4772aUNxn6j9qje84D1wmiOWZyE%3D",
        sasUrl:
          "https://reaidystorage.blob.core.windows.net/resumes?sp=racwdl&st=2025-03-21T06:18:01Z&se=2026-03-21T14:18:01Z&sv=2024-11-04&sr=c&sig=jRlYayZymzSKNbPF4772aUNxn6j9qje84D1wmiOWZyE%3D",
        container: "resumes",
        expiryDate: "21-03-2026",
        accountName: "reaidystorage",
        actions: ["interview", "resume"],
      },
      // {
      //   tittle: "ScreenRecord_storage",
      //   sasToken: "sp=racwdli&st=2024-03-20T18:30:00Z&se=2025-01-20T18:29:00Z&sv=2022-11-02&sr=c&sig=zxleJetbHl7Bk0KQRuJITZayiqQCykH8x1oZsUkTI3A%3D",
      //   sasUrl: "https://reaidystorage.blob.core.windows.net/screen-recordings?sp=racwdli&st=2024-03-20T18:30:00Z&se=2025-01-20T18:29:00Z&sv=2022-11-02&sr=c&sig=zxleJetbHl7Bk0KQRuJITZayiqQCykH8x1oZsUkTI3A%3D",
      //   container: "screen-recodings",
      //   expiryDate: "20-03-2025",
      //   accountName: "reaidystorage",
      //   actions: ["recording"]
      // },
      {
        tittle: "Recordings_storage",
        sasToken:
          "sp=racwdl&st=2025-03-21T06:16:23Z&se=2026-03-21T14:16:23Z&sv=2024-11-04&sr=c&sig=v185ciRWT%2FVgzOTqQWXVSoEvFMOQwQVyfMRouOkGzoA%3D",
        sasUrl:
          "https://reaidystorage.blob.core.windows.net/recordings?sp=racwdl&st=2025-03-21T06:16:23Z&se=2026-03-21T14:16:23Z&sv=2024-11-04&sr=c&sig=v185ciRWT%2FVgzOTqQWXVSoEvFMOQwQVyfMRouOkGzoA%3D",
        container: "recordings",
        expiryDate: "21-03-2026",
        accountName: "reaidystorage",
        actions: ["recording"],
      },
      {
        tittle: "User-media_storage",
        sasToken:
          "sp=racwdl&st=2025-03-21T06:20:10Z&se=2026-03-21T14:20:10Z&sv=2024-11-04&sr=c&sig=YlJGLeMxpSURw3zVeNsCfaaP9FGkc8xdMCyiZUsGN9w%3D",
        sasUrl:
          "https://reaidystorage.blob.core.windows.net/user-media?sp=racwdl&st=2025-03-21T06:20:10Z&se=2026-03-21T14:20:10Z&sv=2024-11-04&sr=c&sig=YlJGLeMxpSURw3zVeNsCfaaP9FGkc8xdMCyiZUsGN9w%3D",
        container: "user-media",
        expiryDate: "21-03-2026",
        accountName: "reaidystorage",
        actions: ["profile", "user"],
      },
    ],
  },
];

export function view(page) {
  const domain = window.location.hostname;
  const whiteLabel = whiteLableList.find((item) => item.domain === domain);

  if (whiteLabel) {
    const menuEntry = whiteLabel.menu.find(
      (menuItem) => menuItem.page === page
    );
    if (menuEntry) {
      return menuEntry.status;
    }
  }

  return false;
}

export function companyView(page) {
  const domain = window.location.hostname;
  const whiteLabel = whiteLableList.find((item) => item.domain === domain);

  if (whiteLabel) {
    const menuEntry = whiteLabel?.company?.find(
      (menuItem) => menuItem.page === page
    );
    if (menuEntry) {
      return menuEntry?.status;
    }
  }

  return false;
}

export function name() {
  const domain = window.location.hostname;
  const whiteLabel = whiteLableList.find((item) => item.domain === domain);

  if (whiteLabel) {
    return whiteLabel.name;
  }
}

export function getclusterbyDomain() {
  const domain = window.location.hostname;
  const whiteLabel = whiteLableList.find((item) => item.domain === domain);

  if (whiteLabel) {
    return whiteLabel.cluster;
  }
  return whiteLableList[0].cluster;
}

export function getLogoBySubdomain(isMobile = false) {
  const domain = window.location.hostname;
  const pathName = window.location.pathname;

  // console.log("domain", domain);

  const whiteLable = whiteLableList.find((item) => item.domain === domain);

  if (whiteLable) {
    if (whiteLable.entireWhiteLabel) {
      if (isMobile) {
        return whiteLable.darkLogo;
      }
      return whiteLable.logo;
    } else if (pathName === "/" || pathName === "/login") {
      return whiteLable.logo;
    } else return reaidy_banner;
  }
  return reaidy_banner;
}

export function getwebsiteUrl() {
  const domain = window.location.hostname;
  const whiteLable = whiteLableList.find((item) => item.domain === domain);

  try {
    if (whiteLable) {
      return whiteLable.websiteUrl;
    }
    return "WWW.REAIDY.IO";
  } catch (error) {
    return "WWW.REAIDY.IO";
  }
  return "https://www.reaidy.io/";
}

export function getLogoForWhiteLabeling(isMobile = false) {
  const domain = window.location.hostname;

  console.log("domain", domain);

  const whiteLable = whiteLableList.find((item) => item.domain === domain);
  if (whiteLable) {
    if (isMobile) {
      return whiteLable.darkLogo;
    }
    return whiteLable.logo;
  }
  return reaidy_banner;
}

export function getSmallLogoForWhiteLabeling() {
  const domain = window.location.hostname;

  console.log("domain", domain);

  const whiteLable = whiteLableList.find((item) => item.domain === domain);
  if (whiteLable) {
    return whiteLable.smallLogo;
  }
  return reaidy_smallLogo;
}

export function getPoweredByLogoForWhiteLabeling() {
  try {
    const domain = window?.location?.hostname;

    console.log("domain", domain);

    const whiteLable = whiteLableList.find((item) => item.domain === domain);
    if (whiteLable) {
      return whiteLable.poweredByLogo;
    }
    return reaidy_banner;
  } catch (error) {
    console.error("Error");
    return reaidy_banner;
  }
}

export function getPoweredByUrlForWhiteLabeling() {
  try {
    const domain = window?.location?.hostname;
    console.log("domain", domain);

    const whiteLable = whiteLableList.find((item) => item.domain === domain);
    if (whiteLable) {
      return whiteLable.poweredByURL;
    }
    return "https://www.reaidy.io/";
  } catch (error) {
    return "https://www.reaidy.io/";
  }
  return reaidy_banner;
}

export function getDomainForWhiteLabeling() {
  const domain = window.location.hostname;

  // console.log("domain", domain);

  const whiteLable = whiteLableList.find((item) => item.domain === domain);
  if (whiteLable) {
    if (whiteLable.domain === "localhost") {
      return "localhost:3000";
    }
    return whiteLable.domain;
  }
  console.log("domain", "app.reaidy.igdgdg");
  return "app.reaidy.io";
}

export function getStorageDataForWhiteLabeling() {
  const domain = window.location.hostname;
  const test_server = process.env.REACT_APP_IS_TEST_SERVER === "true";

  const backup_server =
    process.env.REACT_APP_ENABLE_AZURE_BACKUP_FOR_STORAGE === "true";

  const whiteLable = whiteLableList.find((item) => item.domain === domain);
  if (test_server) {
    console.log("test_server", test_server);
    return productionStorageData; // have commented this line to test the test storage
    // return testStorageData;
  } else if (backup_server) {
    console.log("backup_server", backup_server);
    return backupStorageData;
  } else if (whiteLable) {
    return whiteLable.storageData;
  }
  return productionStorageData;
}
